module.exports = __webpack_public_path__ + "assets/img/img_slbj_s.53997bf8.png";